module.exports = __webpack_public_path__ + "img/683.ba965b3b.png";